import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router'
import { SpinnerLoader } from 'shared/ui'
import { logger } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { ReviewsApi } from 'entities/Review/api/review'
import type { IResponseReview } from 'entities/Review/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ReviewViewStore } from 'pages/reviews/store'
import { ReviewsRoutes } from 'pages/reviews/route/type'
import { EditReviewView } from 'pages/reviews/pages/editReview/ui/EditReviewView'

const SuccessContent = ({
  reviewResponse,
  isDuplicate,
}: {
  reviewResponse: IResponseReview
  isDuplicate?: boolean
}) => {
  const entities = useEntitiesContext()
  const viewPath = `/${ReviewsRoutes.root}/${ReviewsRoutes.view}/`
  const returnTo = uiStore.prevPathName.startsWith(viewPath)
    ? uiStore.prevPathName
    : `/${ReviewsRoutes.root}`
  const [store] = useState(
    () => new ReviewViewStore(entities, reviewResponse, isDuplicate, returnTo)
  )

  return <EditReviewView store={store} />
}

type IEditReviewProps = {
  isDuplicate?: boolean
}

export const EditReview = ({ isDuplicate }: IEditReviewProps) => {
  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [reviewResponse, setReviewResponse] = useState<IResponseReview | null>(null)

  useEffect(() => {
    if (id) {
      ReviewsApi.getReviewById(id)
        .then((res) => {
          if (res) {
            setReviewResponse(res.data.data)
          }
        })
        .catch(logger.error)
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [id])

  if (isLoading) {
    return <SpinnerLoader ariaLabel={'EditReview'} />
  }

  if (reviewResponse) {
    return <SuccessContent reviewResponse={reviewResponse} isDuplicate={isDuplicate} />
  }

  return <Navigate to={`/${ReviewsRoutes.root}`} replace />
}
